<template>
  <div class="cm-terms-of-use my-4 text-muted text-justify">
    <small>While significant efforts were made to ensure accuracy, <span v-html="agencyName"></span> and the carriers represented in this website application assume no responsibility or liability for any errors or omissions in the content provided. The information contained is provided with no guarantees of completeness, accuracy, or currency and without warranties of any kind and users should consult carrier documentation and/or carrier personnel before taking any action. By continuing to use this software, you acknowledge understanding of this disclaimer and agree to be bound by the <b-link href="https://carriermatrix.com/web-application-terms-and-conditions-of-use/" target="_blank">Terms of Use</b-link>. FOR SIMPLICITY FINANCIAL MARKETING HOLDINGS INC. AFFILIATES USE ONLY.
NOT FOR PRODUCER OR CONSUMER USE.</small>
  </div>
</template>

<script>
import {bus} from "@/event-bus";
export default {
  name: "bga-terms-of-use",
  data() {
    return {
      agencyName: '',
    }
  },
  mounted() {
    bus.$on("update-agency-name", agencyName => {
      this.agencyName = agencyName
    })
  },
  props: {},
}
</script>

<style scoped>

</style>